module.exports = __webpack_public_path__ + "img/noImage.fd07dbc1.png";